import { type Opportunity } from "@repo/api";

export const getNonDraftOrdersIds = (project?: Opportunity): string[] => {
  if (!project) {
    return [];
  }

  const nonDraftOrdersIds = project.orders?.allOrders
    ?.sort(
      (a, b) =>
        new Date(b.createdTime).getTime() - new Date(a.createdTime).getTime()
    )
    ?.filter((order) => order.isDraftOrder === false)
    .map((order) => order.orderId);

  return nonDraftOrdersIds ?? [];
};

export const isOrderAddedToProjectValue = (
  orderId: string,
  project?: Opportunity
): boolean => {
  const order = project?.orders?.allOrders?.find((o) => o.orderId === orderId);
  return order ? order.isIncludedInOppValue : false;
};
